"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertGPSToInnerLocations = exports.convertInnerLocationsToGPS = exports.convertGPSToInnerLocation = exports.convertInnerLocationToGPS = exports.innerProjection = void 0;
const proj4_1 = __importDefault(require("proj4"));
exports.innerProjection = {
    code: "EPSG:5514",
    alias: "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs"
};
const convertInnerLocationToGPS = (loc) => {
    proj4_1.default.defs(exports.innerProjection.code, exports.innerProjection.alias);
    // @ts-ignore
    const epsg5514Coordinates = [loc[0], loc[1]];
    const x = Number(epsg5514Coordinates[0]);
    const y = Number(epsg5514Coordinates[1]);
    var coor = (0, proj4_1.default)('EPSG:5514', 'WGS84').forward([x, y]);
    return [coor[1], coor[0]];
};
exports.convertInnerLocationToGPS = convertInnerLocationToGPS;
const convertGPSToInnerLocation = (loc) => {
    proj4_1.default.defs(exports.innerProjection.code, exports.innerProjection.alias);
    const coor = (0, proj4_1.default)('WGS84', 'EPSG:5514').forward([loc[1], loc[0]]);
    return [coor[0], coor[1]];
};
exports.convertGPSToInnerLocation = convertGPSToInnerLocation;
const convertInnerLocationsToGPS = (locs) => {
    return locs.map((group) => {
        return group.map((points) => {
            return (0, exports.convertInnerLocationToGPS)(points);
        });
    });
};
exports.convertInnerLocationsToGPS = convertInnerLocationsToGPS;
const convertGPSToInnerLocations = (locs) => {
    return locs.map((group) => {
        return group.map((points) => {
            return (0, exports.convertGPSToInnerLocation)(points);
        });
    });
};
exports.convertGPSToInnerLocations = convertGPSToInnerLocations;
function useInnerCoordinates() {
    return exports.convertInnerLocationToGPS;
}
exports.default = useInnerCoordinates;
